__turbopack_context__.v({
  "column": "yIX_lq_column",
  "flightSelectorContainer": "yIX_lq_flightSelectorContainer",
  "flightSelectorTitle": "yIX_lq_flightSelectorTitle",
  "wrapper": "yIX_lq_wrapper",
});
